import type { InputProps } from '@presentation/components/Input/types';
import type { CalendarProps } from 'react-calendar';

export interface InputDateProps extends InputProps {
  calendarProps?: CalendarProps;
}
